import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/img/harapan-jaya.png'


const _hoisted_1 = { class: "con-layout-topbar" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  src: _imports_0,
  alt: "hj",
  style: {"height":"50px"}
}
const _hoisted_4 = { class: "content-header flex items-center justify-center pl-2 lg:pl-0 md:pl-0 md:justify-between sm:px-0 lg:justify-between flex-auto" }
const _hoisted_5 = { class: "text-center lg:text-left md:text-left" }
const _hoisted_6 = { class: "lg:right-header md:right-header flex items-center" }
const _hoisted_7 = { class: "biodata mr-3 text-right lg:block md:block hidden" }
const _hoisted_8 = { class: "name-profile" }
const _hoisted_9 = { class: "text-xs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_ProfileDropdown = _resolveComponent("ProfileDropdown")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["layout-topbar", _ctx.store.state.toggleMenu && _ctx.store.state.toggleMinimizeMenu ? 'active minimized' : _ctx.store.state.toggleMenu && !_ctx.store.state.toggleMinimizeMenu ? 'active' : ''])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.$route.path.includes('portal'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_ctx.store.state.toggleMenu)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  innerHTML: _ctx.icon.svg.crossAkarIcons,
                  class: "btn-event-panel p-button-secondary p-button-outlined",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.emitToggle(false)))
                }, null, 8, ["innerHTML"]))
              : (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  innerHTML: _ctx.icon.svg.menuOutlineEva,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.emitToggle(true))),
                  class: "btn-event-panel p-button-secondary p-button-outlined"
                }, null, 8, ["innerHTML"]))
          ]))
        : (_openBlock(), _createElementBlock("img", _hoisted_3)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h6", _hoisted_5, _toDisplayString((_ctx.$route.meta) ? _ctx.$route.meta.group : ''), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.store.state?.userProfile?.given_name), 1),
          _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.store.state?.userProfile?.family_name), 1)
        ]),
        _createVNode(_component_ProfileDropdown)
      ])
    ])
  ], 2))
}